import { render, staticRenderFns } from "./NameEmojiInput.vue?vue&type=template&id=388c2ba2&scoped=true&"
import script from "./NameEmojiInput.vue?vue&type=script&lang=js&"
export * from "./NameEmojiInput.vue?vue&type=script&lang=js&"
import style0 from "./NameEmojiInput.vue?vue&type=style&index=0&id=388c2ba2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388c2ba2",
  null
  
)

export default component.exports